

import './Footer.css';
import logoImg from '../assets/images/1024.png';
import ImageCommerce from '../assets/images/Logo_Ministry_of_Commerce.svg';
import ImageTourism from '../assets/images/ministry-of-tourism.svg';
import ImageVAT from '../assets/images/vat.svg';
import ImageIata from '../assets/images/iata.svg';
import React from 'react';
const Footer = () => (
  <footer style={{ background: 'linear-gradient(90deg, #2E3387 0%, #4e54c8 100%)', color: '#fff', paddingTop: '2.5rem' }}>
    <div className="footer-content" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: '2.5rem', maxWidth: 1100, margin: '0 auto', padding: '0 2rem' }}>
      <div className="footer-section brand" style={{ flex: 2, minWidth: 260, display: 'flex', flexDirection: 'column', gap: '1.2rem' }}>
        <div className="footer-logo" style={{ display: 'flex', alignItems: 'center', gap: '1.2rem' }}>
          <img src={logoImg} alt="Seder Travel Logo" style={{ width: 54, height: 54 }} />
          <div>
            <h3 style={{ fontSize: '1.3rem', margin: 0, color: '#fff', fontWeight: 700, letterSpacing: '0.01em' }}>Seder Travel & Tourism</h3>
            <div style={{ fontSize: '0.95rem', color: '#e3e6fa', marginTop: 2 }}>
              Travel & Tourism Agency
            </div>
          </div>
        </div>
        <p style={{ color: '#e3e6fa', fontSize: '1.05rem', margin: 0, maxWidth: 420 }}>
          Your trusted partner for seamless, luxurious, and unforgettable journeys worldwide.
        </p>
        <div className="contact-info" style={{ display: 'flex', gap: '2.5rem', marginTop: '0.5rem' }}>
          <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', fontSize: '1.08rem' }}>
            <i className="fas fa-phone"></i>
            <span>+011 460 6666</span>
          </div>
          <div className="info-item" style={{ display: 'flex', alignItems: 'center', gap: '0.7rem', fontSize: '1.08rem' }}>
            <i className="fas fa-envelope"></i>
            <span>info@sedertravel.sa</span>
          </div>
        </div>
      </div>
      <div className="footer-section links" style={{ flex: 1, minWidth: 200 }}>
        <h3 style={{ fontSize: '1.15rem', color: '#fff', marginBottom: '1.1rem', fontWeight: 600, letterSpacing: '0.01em' }}>Quick Links</h3>
        <div className="link-columns" style={{ display: 'flex', gap: '2.5rem' }}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
            <li><a href="#home" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>Home</a></li>
            <li><a href="#destinations" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>Destinations</a></li>
            <li><a href="#services" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>Services</a></li>
          </ul>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.7rem' }}>
            <li><a href="#about" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>About Us</a></li>
            <li><a href="#contact" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>Contact</a></li>
            <li><a href="#flights" style={{ color: '#e3e6fa', textDecoration: 'none', fontWeight: 500 }}>Book Flights</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div className="footer-bottom" style={{ marginTop: '2.5rem', textAlign: 'center' }}>
      <div className="footer-line" style={{ height: 1, background: 'rgba(255,255,255,0.18)', margin: '0 0 1.2rem 0', border: 'none' }}></div>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '4.5rem',
        flexWrap: 'wrap',
        marginBottom: '1.2rem',
        background: '#fff',
        borderRadius: '16px',
        padding: '1.2rem 2.2rem',
        boxShadow: '0 2px 12px 0 rgba(44, 62, 80, 0.07)'
      }}>
        {/* IATA */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <img src={ImageIata} alt="IATA" style={{ height: 54 }} />
        </div>
        {/* Ministry of Commerce */}

        {/* VAT */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <img src={ImageVAT} alt="VAT" style={{ height: 54 }} />
          <div style={{ textAlign: 'left' }}>
            <div style={{ color: '#2E3387', fontWeight: 700, fontSize: '0.92rem', marginBottom: 2 }}>ضريبة القيمة المضافة</div>
            <div style={{ color: '#2E3387', fontWeight: 700, fontSize: '0.85rem', marginBottom: 2 }}>VAT Number:</div>
            <div style={{ color: '#2E3387', fontWeight: 600, fontSize: '0.85rem' }}>300049055210003</div>
          </div>
        </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <div style={{ textAlign: 'left' }}>
            <div style={{ color: '#2E3387', fontWeight: 700, fontSize: '0.85rem', marginBottom: 2 }}>CR Number:</div>
            <div style={{ color: '#2E3387', fontWeight: 600, fontSize: '0.85rem' }}>7012536707</div>
          </div>
        </div>
        {/* Ministry of Tourism */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <div style={{ textAlign: 'left' }}>
            <div style={{ color: '#2E3387', fontWeight: 700, fontSize: '0.85rem', marginBottom: 2 }}>License No:</div>
            <div style={{ color: '#2E3387', fontWeight: 600, fontSize: '0.85rem' }}>73105703</div>
          </div>
        </div>
      </div>
      <p style={{ color: '#e3e6fa', fontSize: '1rem', margin: 0 }}>&copy; {new Date().getFullYear()} Seder Travel. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
